/** @jsx jsx */
import { jsx } from "@trueskin-web/theme"

import Heading from "../heading"

const CardContent = ({ title, description, image }) => (
  <div
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    <div
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "flex-start",
      }}
    >
      <Heading size="sm" sx={{ lineHeight: 1.33 }}>
        {title}
      </Heading>

      {image}
    </div>

    <div
      sx={{
        fontSize: 1,
        color: "textDark",
      }}
    >
      {description}
    </div>
  </div>
)

export default CardContent
